import axios from "axios";

export const apiInstance = axios.create({
    baseURL: "/local/components/codeking/excursions_2/api/"
});

export async function apiGet(url: string,query: Record<string,string> = {}){
    return (await apiInstance.get(url,{
        params: query
    })).data;
}
